import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=89c8ac6c&"
import script from "./OrderComponent.vue?vue&type=script&lang=js&"
export * from "./OrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports